import { z } from "zod";
import type { CabinetState } from "../../../context/StoreContext";
import type { VerticalSide } from "./Compartment";

export const HorizontalSchema = z.object({
	id: z.string(),
	x: z.number(),
	y: z.number(),
	z: z.number(),
	width: z.number().max(1180).min(150),
	height: z.number(),
	depth: z.number(),
});

export type Horizontal = z.infer<typeof HorizontalSchema>;

export function getNextHorizontal(
	horizontal: Horizontal,
	direction: VerticalSide,
	state: CabinetState,
): undefined | Horizontal {
	return [...state.horizontals.values()].find((h) => {
		const isNextTo =
			direction === "right"
				? horizontal.x + horizontal.width === h.x
				: horizontal.x === h.x + h.width;

		return horizontal.y === h.y && isNextTo;
	});
}
